const visitRouter = [
    {
        path: "list-visit_list",
        name: "list",
        component: () => import("@/views/admin/visit"),
        default: true,
        meta: {
            model: "rental_order_buy",
            // requiresAuth: true,
        },
    },
    {
        path: "list-visit_list/add",
        name: "add",
        component: () => import("@/views/admin/visit/function"),
        default: true,
        meta: {
            model: "rental_order_buy",
            // requiresAuth: true,
        },
    },
    {
        path: "list-visit_list/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/visit/function"),
        default: true,
        meta: {
            model: "rental_order_buy",
            // requiresAuth: true,
        },
    },
  ];
  export default visitRouter;